import {gql} from "@apollo/client";

const CREATE_PAYMENT_INTENT =
gql`
    mutation CreatePaymentIntent($eventId: String!, $amount: String!) {
        createPaymentIntent(eventId: $eventId, amount: $amount)
    }
`;

export { CREATE_PAYMENT_INTENT };